/**
 * Lot lock - a card that is physically out for grading or repair is "locked":
 * it cannot be traded, sold, or otherwise disposed of until its submission is
 * marked Returned. Mirrors the database guardrail (a card in an active
 * grading/repair submission is rejected by trade_outgoing / sale_items triggers).
 */
import { DB } from "./db";

/** Card statuses meaning the card is physically out and must not be disposed. */
export const LOCKED_CARD_STATUSES = ["At Grading", "Repair"] as const;

/** Human reason a card lot is locked, or null if it is free to act on.
 *  Only applies to card lots; sealed lots are never grading/repair-locked. */
export function cardLockReason(lotId: string): string | null {
  if (!lotId) return null;
  const row = DB.table("cards").find(r => r["Card Lot ID"] === lotId);
  if (!row) return null;
  const status = String(row["Status"] || "");
  if (status === "At Grading") return "out for grading";
  if (status === "Repair")     return "out for repair";
  return null;
}

/** True when the lot is currently locked (out for grading/repair). */
export function isLotLocked(lotId: string): boolean {
  return cardLockReason(lotId) !== null;
}
